import { render, staticRenderFns } from "./diffModal.vue?vue&type=template&id=77db61f6&scoped=true"
import script from "./diffModal.vue?vue&type=script&lang=js"
export * from "./diffModal.vue?vue&type=script&lang=js"
import style0 from "./diffModal.vue?vue&type=style&index=0&id=77db61f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77db61f6",
  null
  
)

export default component.exports